import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '@/shared/utils/cn/cn.util';

import { badgeVariants, type BadgeVariants } from './Badge.tokens';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, BadgeVariants {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { className, tone, variant, ...props },
  ref,
) {
  return <span ref={ref} className={cn(badgeVariants({ tone, variant }), className)} {...props} />;
});
